import { EmployeeAddressMutationDTO } from "../../models/employee-addresses/mutations/employee-address-mutation-dto";
import { EmployeeAddressMutationSTO } from "../../models/employee-addresses/mutations/employee-address-mutation-sto";
import { MutationsFilter } from "../../models/mutations/mutations-filter";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeCurrentAddressMutationsApiService extends BaseApiService<
  EmployeeAddressMutationDTO,
  EmployeeAddressMutationSTO
> {
  constructor() {
    super({
      servicePath: "/EmployeeAddressMutations",
      loadItemsPath: "/GetCurrentEmployeeAddressMutations",
      saveItemsPath: "/SaveCurrentEmployeeAddressMutations",
    });
  }
}

export const loadEmployeeCurrentAddressMutations = async (
  employeeId: string,
  forManager: boolean,
  signal?: AbortSignal
) => {
  const apiService = new EmployeeCurrentAddressMutationsApiService();

  if (forManager) {
    apiService.useLoadItemsPath("/GetCurrentEmployeeAddressMutations");
  }

  const response = await apiService.loadItems(
    { employeeId } as MutationsFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  return response;
};
